import React from 'react'
import DashHeader from '../components/DashHeader'
import DashSide from '../components/DashSide';
import Form from '../components/Form';

const Admin = () => {
    return (
      <div className='w-screen'>
        <div className=''>
          <DashHeader/>
        </div>  
        <div className='flex'>
          <div>
            <DashSide/>
          </div> 
          <Form/>
        </div>
      </div>  
    )
}
export default Admin;